import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { __, translateBackendErrorCode } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
export const PointsTrigger = (props) => {
    const { articleId, setArticleData, isArticleRead, isInEditor } = props;
    const POINTS_TRIGGER = "pointsTrigger";
    const setIsRead = () => setArticleData((prevState) => ({ ...prevState, is_read: true }));
    useEffect(() => {
        const user = getUser();
        const isUserAuthenticated = user.uuid && user.ciam_token;
        const isArticleIdProvided = Boolean(articleId);
        if (isInEditor || isArticleRead || !isUserAuthenticated || !isArticleIdProvided)
            return;
        const pointsTrigger = document.getElementById(POINTS_TRIGGER);
        const handleIntersection = (entries, self) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    LoyaltyApi.init()
                        .readArticleAction(articleId, user.ciam_token)
                        .then(() => {
                        setIsRead();
                        toast.success(__("loyalty.articlePoints.trigger.success"));
                    })
                        .catch((e) => {
                        const error = translateBackendErrorCode(e.error_code, __("loyalty.articlePoints.trigger.error"));
                        toast.error(error);
                    });
                    self.disconnect();
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 1,
        });
        observer.observe(pointsTrigger);
    }, []);
    return (_jsx("div", { className: POINTS_TRIGGER, id: POINTS_TRIGGER, "data-testid": POINTS_TRIGGER, children: isInEditor &&
            "Points trigger component, this is not visible on publish. Points will be assigned when this component reach viewport." }));
};
//# sourceMappingURL=PointsTrigger.js.map